<script setup>
import SportLiveTvButton from '@/sport-live-tv/components/sport-live-tv-button.vue';
import { useSportLiveTvTranslation } from '@/sport-live-tv/composables/use-sport-live-tv-translation';

const emit = defineEmits(['clear', 'apply']);

const { t } = useSportLiveTvTranslation();
</script>

<template>
  <div class="sport-live-tv-filter-actions">
    <SportLiveTvButton variant="secondary" :label="t('clearAll')" @click="emit('clear')" />
    <SportLiveTvButton :label="t('applyFilters')" @click="emit('apply')" />
  </div>
</template>

<style lang="scss" scoped>
.sport-live-tv-filter-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;

  @include mobile-sm-max {
    flex-direction: column-reverse;
    align-items: stretch;
  }
}
</style>
